import { app } from '@microsoft/teams-js'

const useIsMSTeams = () => {
  return app.isInitialized()
}

export default useIsMSTeams
